import api from "../../../services/api";
import { ContractStatus, ContractType } from "../enums/contractEnums";
import {
  Contract,
  CreateContractRequest,
  UpdateContractRequest,
  ContractApiResponse,
} from "../types/contract";

const BASE_URL = `${process.env.REACT_APP_API_HOST}project-module/contract`;

// Get contract by ID
export const getContractById = async (
  id: string
): Promise<ContractApiResponse<Contract>> => {
  try {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error: error.response?.data?.message || "Failed to fetch contract",
      details: error.response?.data?.details,
    };
  }
};

// Get contracts by project ID
export const getContractByProjectId = async (
  projectId: string
): Promise<ContractApiResponse<Contract>> => {
  try {
    const response = await api.get(`${BASE_URL}/project/${projectId}`);
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error:
        error.response?.data?.message || "Failed to fetch project contracts",
      details: error.response?.data?.details,
    };
  }
};

// Create new contract
export const createContract = async (
  data: CreateContractRequest
): Promise<ContractApiResponse<Contract>> => {
  try {
    const response = await api.post(BASE_URL, data);
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error: error.response?.data?.message || "Failed to create contract",
      details: error.response?.data?.details,
    };
  }
};

// Update contract
export const updateContract = async (
  id: string,
  data: UpdateContractRequest
): Promise<ContractApiResponse<Contract>> => {
  try {
    const response = await api.put(`${BASE_URL}/${id}`, data);
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error: error.response?.data?.message || "Failed to update contract",
      details: error.response?.data?.details,
    };
  }
};

// Delete contract (soft delete)
export const deleteContract = async (
  id: string
): Promise<ContractApiResponse<void>> => {
  try {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error: error.response?.data?.message || "Failed to delete contract",
      details: error.response?.data?.details,
    };
  }
};

export const updateContractStatus = async (
  id: string,
  status: ContractStatus
): Promise<ContractApiResponse<Contract>> => {
  try {
    const response = await api.patch(`${BASE_URL}/${id}/status`, { status });
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error:
        error.response?.data?.message || "Failed to update contract status",
      details: error.response?.data?.details,
    };
  }
};

export const getContractBySuperProjectId = async (
  superProjectId: string
): Promise<ContractApiResponse<Contract>> => {
  try {
    const response = await api.get(
      `${process.env.REACT_APP_API_HOST}project-module/super-projects/${superProjectId}/contract`
    );
    return response.data;
  } catch (error: any) {
    return {
      isSuccess: false,
      error:
        error.response?.data?.message ||
        "Failed to fetch super project contract",
      details: error.response?.data?.details,
    };
  }
};
